import ym from 'react-yandex-metrika';
import config from '../config/config';

function sendGoal(targetName) {
  try {
    if (typeof ym !== 'undefined') return ym('reachGoal', targetName);

    if (typeof window.ym === 'undefined' || config.isDev) return;

    const isMarketplace = window.Widget.settings.theme === 'marketplace';
    const { yMetrikaID, yMetrikaIDMarket } = config;

    window.ym(isMarketplace ? yMetrikaIDMarket : yMetrikaID, 'reachGoal', targetName);
  } catch (error) {
    console.log(error);
  }
}

export { sendGoal };
